import { jsPDF } from "jspdf";
import "../../../Assets/ptags/fonts/Montserrat-Bold";
import "../../../Assets/ptags/fonts/Montserrat-ExtraBold";
import "../../../Assets/ptags/fonts/Montserrat-Black";
import "../../../Assets/ptags/fonts/Montserrat-ExtraBoldItalic";
import "../../../Assets/ptags/fonts/Montserrat-BoldItalic";
import "../../../Assets/ptags/fonts/anton";
import { getAdjustedPrice } from "../../../Services/Api";
import logored from "../../../Assets/logored.png"

const now = new Date();
const timestamp = now
    .toISOString()
    .replace(/[:.]/g, '-')
    .replace('T', '_')
    .split('Z')[0];

export const generatePDFOpt3_TwoCols_2 = (sectionsData, bannerImg) => {

    const pageHeight = 816;
    const pageWidth = 1056;

    const doc = new jsPDF({
        // orientation: "portrait",
         orientation: "landscape",
        unit: "pt",
        format: [pageWidth, pageHeight],
    });

    const sectionWidth = pageWidth / 2;
    const sectionHeight = pageHeight;
    const bannerImgHeight = 80;
    const maxSectionsPerPage = 2;

    let currentSection = 0;

    while (currentSection < sectionsData.length) {
        if (currentSection > 0) doc.addPage();

        const sectionsOnThisPage = Math.min(maxSectionsPerPage, sectionsData.length - currentSection);

        for (let i = 0; i < sectionsOnThisPage; i++) {
            const sectionIndex = currentSection + i;
            const section = sectionsData[sectionIndex];
            if (!section) continue;

            const col = i % 2;
            const row = Math.floor(i / 2);
            const xPos = col * sectionWidth;
            const yPos = row * sectionHeight;

            console.log("https://fdapi.thefurnituredepots.com/" + sectionsData[sectionIndex]?.individuals[0]?.image?.image_url, "here is ")

            const productImageUrl = sectionsData[sectionIndex]?.image; // main image
            const productImageUrl2 = "https://fdapi.thefurnituredepots.com" + sectionsData[sectionIndex]?.individuals[0]?.image?.image_url; // secondary
            const productImageUrl3 = "https://fdapi.thefurnituredepots.com" + sectionsData[sectionIndex]?.individuals[1]?.image?.image_url; // secondary
            const name = section.name || "";
            const sku = "SKU: " + (section.sku || "");
            const sku_2 = "SKU: " + (sectionsData[sectionIndex]?.individuals[0]?.sku || "");
            const sku_3 = "SKU: " + (sectionsData[sectionIndex]?.individuals[1]?.sku || "");
            const variation = section.variations?.[0];
            const sale_price = variation?.sale_price || 0;
            const was_price = variation?.regular_price || 0;
            // Banner
            const bannerImgWidth = sectionWidth - 5;

            // Main Image
            const imgY = yPos + bannerImgHeight + 5;
            const imgHeight = sectionHeight * 0.55; // space for bottom boxes
            const imgWidth = sectionWidth * 0.95;   // main image width
            const imgX = xPos + (sectionWidth - imgWidth) / 2;

            if (productImageUrl) {
                // Draw container (border) for main image
                doc.setLineWidth(2);
                doc.setDrawColor(71, 74, 119);
                // x, y, width, height

                // Add main image
                doc.addImage(productImageUrl, "JPEG", imgX, imgY - 40, imgWidth, imgHeight - 80);
                doc.rect(xPos + 5, imgY - 2, bannerImgWidth - 5, imgHeight - 160);
            }

            // Small images below main image
            const smallImgHeight = 130;
            const smallImgWidth = 190;
            const gapPED = 20;
            const totalWidth = smallImgWidth * 2 + gapPED;

            // Center the two small images
            const smallImgXStart = xPos + (sectionWidth - totalWidth) / 2;
            const smallImgY = imgY - 52 + (imgHeight - 102);


            const rectWidth = (sectionWidth / 2) - 5;
            const rectHeight = smallImgHeight + 27;


            // Image 2 → left of center
            if (productImageUrl2) {
                // Draw rectangle
                const rect2X = xPos + 5;
                const rect2Y = smallImgY - 3;
                doc.setLineWidth(2);
                doc.setDrawColor(71, 74, 119);
                doc.rect(rect2X, rect2Y, rectWidth, rectHeight);

                // Center image inside rectangle
                const img2X = rect2X + (rectWidth - smallImgWidth) / 2;
                const img2Y = rect2Y + (rectHeight - smallImgHeight) / 2;

                doc.addImage(productImageUrl2, "JPEG", img2X, img2Y, smallImgWidth, smallImgHeight);
                // Draw SKU2 bottom-right
                doc.setFont("Montserrat-Bold", "bold");
                doc.setFontSize(10);
                doc.setTextColor(0, 0, 0);

                const sku2Text = sku_2 || "";
                doc.text(
                    sku2Text,
                    rect2X + rectWidth - 5,               // X = right side
                    rect2Y + rectHeight - 5,              // Y = bottom side
                    { align: "right" }
                );

            }


            // Image 3 → right of center
            if (productImageUrl3) {
                // Draw rectangle
                const rect3X = xPos + 5 + rectWidth;
                const rect3Y = smallImgY - 3;
                doc.setLineWidth(2);
                doc.setDrawColor(71, 74, 119);
                doc.rect(rect3X, rect3Y, rectWidth, rectHeight);

                // Center image inside rectangle
                const img3X = rect3X + (rectWidth - smallImgWidth) / 2;
                const img3Y = rect3Y + (rectHeight - smallImgHeight) / 2;

                doc.addImage(productImageUrl3, "JPEG", img3X, img3Y, smallImgWidth, smallImgHeight);
                // Draw SKU3 bottom-right
                doc.setFont("Montserrat-Bold", "bold");
                doc.setFontSize(10);
                doc.setTextColor(0, 0, 0);

                const sku3Text = sku_3 || "";
                doc.text(
                    sku3Text,
                    rect3X + rectWidth - 5,               // X = right side
                    rect3Y + rectHeight - 5,              // Y = bottom side
                    { align: "right" }
                );

            }

            // Banner image at top
            doc.addImage(bannerImg, "JPEG", xPos + 2.5, yPos, bannerImgWidth, bannerImgHeight);



            // Overlay Name & SKU (top-right of image)
            doc.setFont("Montserrat-Bold", "bold");
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(14);
            doc.text(name, xPos + sectionWidth - 8, imgY + 15, { align: "right" });

            doc.setFontSize(14);
            doc.setFont("helvetica", "normal");
            doc.text(sku, xPos + sectionWidth - 8, imgY + 33, { align: "right" });

            // Bottom Container: 2 rows x 2 columns with different heights
            const bottomBoxY = imgY + imgHeight + 5;
            const bottomBoxHeightTotal = sectionHeight - (bottomBoxY - yPos) - 5;

            // Top row 70%, Bottom row 30%
            const topRowHeight = bottomBoxHeightTotal * 0.60;
            const bottomRowHeight = bottomBoxHeightTotal * 0.40;

            const bottomBoxWidth = sectionWidth - 10;
            const bottomBoxX = xPos + 5;
            const gap = 0;
            const halfWidth = (bottomBoxWidth - gap) / 2;

            // Row heights array
            const rowHeights = [topRowHeight, bottomRowHeight];

            for (let r = 0; r < 2; r++) {
                const rowY = bottomBoxY + (r === 0 ? 0 : topRowHeight);

                // Left box
                doc.setLineWidth(2);
                doc.setDrawColor(71, 74, 119);
                doc.rect(bottomBoxX, rowY, halfWidth, rowHeights[r], "S");

                // Right box
                const rightBoxX = bottomBoxX + halfWidth + gap;
                doc.rect(rightBoxX, rowY, halfWidth, rowHeights[r], "S");


                if (r === 0) {
                    const leftCenterX = bottomBoxX + halfWidth / 2;
                    const leftCenterY = rowY + 45;

                    // ===== Line 1: Variation text =====
                    const text1 = section?.variations?.[0]?.value || "";
                    doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                    doc.setTextColor(40, 142, 169);
                    doc.setFontSize(12);
                    const text1Width = doc.getTextWidth(text1);
                    doc.text(text1, leftCenterX - text1Width / 2, leftCenterY - 25);

                    // ===== Line 2: "was $XX" =====
                    const text2 = "was $" + was_price;
                    doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(16);
                    const text2Width = doc.getTextWidth(text2);
                    doc.text(text2, leftCenterX - text2Width / 2, leftCenterY - 7);

                    // ===== Line 3: Sale price =====
                    const text3 = "$" + sale_price;
                    doc.setFont("Montserrat-Black", "normal");
                    doc.setTextColor(253, 0, 0);
                    doc.setFontSize(50);
                    const text3Width = doc.getTextWidth(text3);
                    doc.text(text3, leftCenterX - text3Width / 2, leftCenterY + 35);

                    // ===== If multiple variations → show group pricing below sale price =====
                    if (section?.variations?.length > 1) {
                        const xPos = leftCenterX - halfWidth / 2 + 10;
                        let lineY = leftCenterY + 45; // start just below the large price

                        // Loop through remaining variations
                        for (let index = 1; index < section.variations.length; index++) {
                            const variation = section.variations[index];
                            const yOffset = lineY + index * 15; // 15px between lines

                            // Variation value
                            doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                            doc.setTextColor(0, 0, 0);
                            doc.setFontSize(10);
                            const valueText = variation?.value || "N/A";
                            doc.text(valueText, xPos, yOffset);

                            // Sale price
                            const valueWidth = doc.getTextWidth(valueText);
                            doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                            doc.setTextColor(253, 0, 0);
                            doc.setFontSize(10);
                            doc.text(`$${variation?.sale_price || "0.00"}`, xPos + valueWidth + 5, yOffset);
                        }
                    }

                    // ===== Right box: Adjusted price & financing details =====
                    const rightCenterX = rightBoxX + halfWidth / 2;

                    // define top and bottom of container
                    const boxTopY = rowY;
                    const boxBottomY = rowY + rowHeights[r];
                    const paddingTop = 20;
                    const paddingBottom = 20;

                    let currentY = boxTopY + paddingTop;

                    // ===== TOP: Price text =====
                    const text1_main = "$" + getAdjustedPrice((sale_price !== 0 && sale_price !== "") ? sale_price : was_price).toString();
                    const text1_suffix = "/week";

                    doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                    doc.setFontSize(24);
                    const width_main = doc.getTextWidth(text1_main);

                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(14);
                    const width_suffix = doc.getTextWidth(text1_suffix);

                    const totalWidth = width_main + width_suffix + 2;
                    const combinedTextX = rightCenterX - totalWidth / 2;

                    doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                    doc.setTextColor(253, 0, 0);
                    doc.setFontSize(30);
                    doc.text(text1_main, combinedTextX - 20, currentY + 20);

                    doc.setFont("helvetica", "bold");
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(18);
                    doc.text(text1_suffix, combinedTextX + (width_main - 7), currentY + 20);


                    // ===== Middle small text =====
                    currentY += 12;
                    doc.setFont("helvetica", "normal");
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(12);
                    doc.text(
                        ["Subject to approval, some", "restrictions apply"],
                        rightCenterX,
                        currentY + 25,
                        { align: "center" }
                    );

                    // ===== BOTTOM texts (anchored to bottom) =====
                    const lineSpacing = 15; // space between bottom texts
                    const bottomText2Y = boxBottomY - paddingBottom; // last line (100 DAYS NO INTEREST)
                    const bottomText1Y = bottomText2Y - lineSpacing; // line above it (NO CREDIT 0 DOWN)

                    doc.setFont("Montserrat-ExtraBold", "normal");
                    doc.setTextColor(253, 0, 0);
                    doc.setFontSize(17);
                    doc.text("NO CREDIT 0 DOWN", rightCenterX, bottomText1Y, { align: "center" });

                    doc.setFont("Montserrat-ExtraBold", "normal");
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(14);
                    doc.text("100 DAYS NO INTEREST", rightCenterX, bottomText2Y, { align: "center" });

                }

                // Bottom row left box (3rd container on the page)
                if (r === 1) {
                    const bottomLeftX = bottomBoxX;
                    const bottomLeftY = bottomBoxY + topRowHeight;
                    const bottomLeftWidth = halfWidth;
                    const bottomLeftHeight = bottomRowHeight;

                    // Fixed: 3 rows, 4 columns (Label1, Price1, Label2, Price2)
                    const cols = 4;
                    const rows = 3;
                    const col1 = bottomLeftWidth * 0.3; // label1
                    const col2 = bottomLeftWidth * 0.2; // price1
                    const col3 = bottomLeftWidth * 0.3; // label2
                    const col4 = bottomLeftWidth * 0.2; // price2
                    const rowHeight = bottomLeftHeight / rows;

                    const values = section?.individuals || [];
                    const itemsPerRow = 2; // (label + price) × 2
                    const totalItems = rows * itemsPerRow; // 6 slots total

                    // Draw outer border
                    doc.setLineWidth(1.5);
                    doc.rect(bottomLeftX, bottomLeftY, bottomLeftWidth, bottomLeftHeight, "S");

                    // Draw horizontal lines (3 rows → 2 internal lines)
                    for (let i = 1; i < rows; i++) {
                        const y = bottomLeftY + i * rowHeight;
                        doc.line(bottomLeftX, y, bottomLeftX + bottomLeftWidth, y);
                    }

                    // Draw vertical lines for 4 custom-width columns
                    const colX1 = bottomLeftX + col1;
                    const colX2 = colX1 + col2;
                    const colX3 = colX2 + col3;

                    doc.line(colX1, bottomLeftY, colX1, bottomLeftY + bottomLeftHeight);
                    doc.line(colX2, bottomLeftY, colX2, bottomLeftY + bottomLeftHeight);
                    doc.line(colX3, bottomLeftY, colX3, bottomLeftY + bottomLeftHeight);

                    // Now fill data row by row (always 3 rows)
                    for (let row = 0; row < rows; row++) {
                        const y = bottomLeftY + row * rowHeight + rowHeight / 2 + 4;

                        const leftIndex = row * itemsPerRow;
                        const rightIndex = leftIndex + 1;

                        // Left item (Label1 + Price1)
                        if (values[leftIndex]) {
                            const left = values[leftIndex];
                            const label = left.inputValue || "";
                            const price = left.p_price ? "$" + left.p_price : "";

                            const labelX = bottomLeftX + col1 / 2 - 30;
                            const priceX = bottomLeftX + col1 + col2 / 2 - 15;

                            doc.setFont("Montserrat-BoldItalic", "bolditalic");
                            doc.setFontSize(12);
                            doc.setTextColor(0, 0, 0);
                            doc.text(label, labelX + 4, y, { align: "left" });
                            doc.setFontSize(12);
                            doc.setFont("Montserrat-BoldItalic", "bolditalic");
                            doc.setTextColor(252, 0, 0);
                            doc.text(price, priceX, y, { align: "left" });
                        }

                        // Right item (Label2 + Price2)
                        if (values[rightIndex]) {
                            const right = values[rightIndex];
                            const label = right.inputValue || "";
                            const price = right.p_price ? "$" + right.p_price : "";

                            const labelX = bottomLeftX + col1 + col2 + col3 / 2 - 30;
                            const priceX = bottomLeftX + col1 + col2 + col3 + col4 / 2 - 15;

                            doc.setFont("Montserrat-BoldItalic", "bolditalic");
                            doc.setFontSize(12);
                            doc.setTextColor(0, 0, 0);
                            doc.text(label, labelX + 4, y, { align: "left" });
                            doc.setFontSize(12);
                            doc.setFont("Montserrat-BoldItalic", "bolditalic");
                            doc.setTextColor(252, 0, 0);
                            doc.text(price, priceX, y, { align: "left" });
                        }
                    }
                }



                // Only draw the bottom-right box in the bottom row (r === 1)
                if (r === 1) {
                    const bottomRightX = rightBoxX;
                    const bottomRightY = rowY; // bottom row
                    const bottomRightWidth = halfWidth;
                    const bottomRightHeight = rowHeights[r];

                    // Draw outer border
                    doc.setLineWidth(1.5);
                    doc.rect(bottomRightX, bottomRightY, bottomRightWidth, bottomRightHeight, "S");

                    // Divider at 60% / 40%
                    const dividerY = bottomRightY + bottomRightHeight * 0.6;
                    doc.line(bottomRightX, dividerY, bottomRightX + bottomRightWidth, dividerY);

                    // ===== Top section (60%) text remains the same =====
                    const topCenterX = bottomRightX + bottomRightWidth / 2;
                    const topCenterY = bottomRightY + (dividerY - bottomRightY) / 2;

                    doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                    doc.setFontSize(22);
                    doc.setTextColor(232, 106, 2);
                    doc.text("5 YEARS", topCenterX, topCenterY, { align: "center" });
                    doc.setFontSize(13);
                    doc.setTextColor(0, 0, 0);
                    doc.text("PROTECTION PLAN", topCenterX, topCenterY + 18, { align: "center" });

                    // ===== Bottom section (40%) image =====
                    const bottomCenterY = dividerY + (bottomRightY + bottomRightHeight - dividerY) / 2;

                    // Image settings
                    const imgWidth = bottomRightWidth * 0.9;  // 50% of box width
                    const imgHeight = (bottomRightHeight * 0.4) * 0.6; // 60% of bottom section height
                    const imgX = bottomRightX + (bottomRightWidth - imgWidth) / 2;
                    const imgY = dividerY + ((bottomRightHeight * 0.4) - imgHeight) / 2;

                    // Add PNG image
                    doc.addImage(logored, "PNG", imgX, imgY, imgWidth, imgHeight);
                }







            }

            // Dashed lines between sections (optional)
            doc.setLineWidth(1);
            doc.setDrawColor(0, 0, 0);
            doc.setLineDashPattern([5, 3], 0);

            if (row === 0) {
                const yDash = yPos + sectionHeight;
                doc.line(xPos, yDash - 2, xPos + sectionWidth, yDash - 2);
            }
            if (col === 0) {
                const xDash = xPos + sectionWidth;
                doc.line(xDash, yPos, xDash, yPos + sectionHeight);
            }

            doc.setLineDashPattern([], 0);
        }

        currentSection += sectionsOnThisPage;
    }

    doc.save(`price-tags_${timestamp}.pdf`);
};
